module.exports = require("@hs/icons");